import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

const ZONE = 'zone';

export const Zone = {
  id: ZONE,
  type: OptionFormTypes.TYPE_NUMBER_COMPARISON,
  filterValue: 'Zone',
  displayName: <FormattedMessage {...messages[ZONE]} />,

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_NUMBER_COMPARISON, criteriaInformations);
  },

  mapV2SavedFilterToV3Applied: ({ value }) => ({
    criterionArgumentValue: Number.parseInt(value, 10),
  }),
};
